<template>
  <section class="main">
            <div class="content_page_title">
                <h1>Réinitialisation du mot de passe</h1>
            </div>
            <div class="main_content">
              <form ref="form" v-on:submit.prevent>
                <div class="form">
                  <div class="form_message">
                    <div class="form_message_text">
                      Merci de bien vouloir renseigner l'adresse mail utilisée pour la connexion.
                    </div>
                  </div>
                    <div class="line half">
                      <div class="form_group full">
                        <label for="mail">Adresse mail</label>
                        <input id="mail" type="email" placeholder="Email" v-model="mail" required />
                      </div>
                    </div>
                    <div class="form_actions_bar">
                      <input type="submit" value="Valider" class="blue button" @click="handleOk" />
                    </div>
                    <a href="index.html" class="button dark">Retour à l'accueil</a>
                </div>
              </form>
            </div>
        </section>
    </template>

<script>

import axios from 'axios'

export default {
  name: 'LostPassword',
  components: {},

  data() {
    return {
      mail: null
    }
  },

  created() {},

  destroyed() {
    this.mail = null;
  },

  methods: {
    handleOk() {
      if(this.$refs['form'].checkValidity()) {
        axios.get('utilisateur/lostpassword', {
          params: {
            identifiant: this.mail
          }
        }).then((response) => {
          if(response.data) {
            this.$router.push('/');
            this.$notify({
              group: 'general-notification',
              type: 'success',
              text: "Un mail vous a été adressé à l'adresse fournie pour réinitialiser votre mot de passe"
            });
          } else {
            this.$notify({
              group: 'general-notification',
              type: 'error',
              text: "Aucun compte lié à cette adresse mail n'a été trouvé"
            });
          }
        });
      }
    }
  }

}
</script>

<style>
</style>
